import { RefundableStatusTypes } from "@/common/enums";

export default class RefundModel  {
    status: RefundableStatusTypes | undefined;

    static from(json: string): RefundModel {
        let model = Object.assign(new RefundModel(), json);
        return model;
    }
}